import en from './rewardsString.en';

export default {
  en,
};
